/* rail arrows (direction-aware) and footer menus open on desktop. */
(() => {
  const rails = document.querySelectorAll('[data-sh-carousel]');
  rails.forEach((sec) => {
    const rail = sec.querySelector('.sh-rail');
    if (!rail) return;
    const prev = sec.querySelector('.sh-rail__btn--prev');
    const next = sec.querySelector('.sh-rail__btn--next');
    const rtl = () => getComputedStyle(rail).direction === 'rtl';
    const step = () => {
      const item = rail.querySelector('.sh-rail__item');
      return item ? (item.getBoundingClientRect().width + 8) * 2 : rail.clientWidth * 0.8;
    };
    const update = () => {
      const max = rail.scrollWidth - rail.clientWidth;
      const pos = Math.abs(rail.scrollLeft);
      if (prev) prev.disabled = pos < 4;
      if (next) next.disabled = pos > max - 4;
    };
    [prev, next].forEach((b) => b && b.addEventListener('click', () => {
      const d = Number(b.dataset.dir) * (rtl() ? -1 : 1);
      rail.scrollBy({ left: d * step(), behavior: 'smooth' });
    }));
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
  const mq = window.matchMedia('(min-width: 750px)');
  const sync = () => document.querySelectorAll('.sh-fmenu').forEach((d) => { if (mq.matches) d.setAttribute('open', ''); else d.removeAttribute('open'); });
  sync();
  mq.addEventListener('change', sync);
})();
